import actionTypes from '../constants/action-types';

const setServiceConfig = (config) => ({
  type: actionTypes.SET_SERVICE_CONFIG,
  payload: {
    config,
  },
});

export default setServiceConfig;
